import type { FunctionComponent } from 'react';

import { useBooleanFlags } from '@/core/flags/flags.hooks';
import { ProductContainer } from '@/domains/productDiscovery/ProductPage/modules/ProductContainer/ProductContainer.default';
import { StringAbTests } from '@/productDiscovery/ProductPage/constants';
import { ProductPageProvider } from '@/productDiscovery/ProductPage/ProductPageProvider';
import { ProductContainerRevamp } from '@/productDiscovery/ProductPage/ProductPageRevamp';

export const ProductPage: FunctionComponent = () => {
  const [isProductPageRevampEnabled] = useBooleanFlags([
    StringAbTests.ENABLE_PRODUCT_PAGE_REVAMP,
  ]);

  return (
    <ProductPageProvider>
      {isProductPageRevampEnabled ? (
        <ProductContainerRevamp />
      ) : (
        <ProductContainer />
      )}
    </ProductPageProvider>
  );
};

ProductPage.displayName = 'ProductPage';
